(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bulk-estimator"] && !Shopify.designMode) return;
  try {
    (function () {
    var LABELS = ['No customisation','Brand mark only','Brand mark + lining','Full bespoke'];
    var DESCS  = [
      'Standard bag with no branding. Ready to ship.',
      'Includes debossed or screen-printed brand mark on flap or body.',
      'Brand mark placement plus choice of 8 interior canvas lining colours.',
      'All options: brand mark, lining colour, strap finish, hardware tone, and trim detail.'
    ];

    function fmt(n) { return '\u20B9' + Math.round(n).toLocaleString('en-IN'); }
    function disc(q) { return q >= 500 ? 0.20 : q >= 250 ? 0.15 : q >= 150 ? 0.08 : 0; }

    window.deveCalc = function (id, base, mark, lining, bespoke) {
      var ADDS = [0, mark, lining, bespoke];
      var qty  = parseInt(document.getElementById('deve-qty-' + id).value) || 0;
      var tier = parseInt(document.getElementById('deve-tier-' + id).value);
      // Add this after the tier desc line:
      var tierDesc = document.getElementById('deve-tier-desc-' + id);
      if (qty < 100) {
        tierDesc.textContent = 'Minimum order quantity is 100 units';
        tierDesc.style.color = 'var(--deve-danger)';
      } else {
        tierDesc.textContent = DESCS[tier];
        tierDesc.style.color = '';
      }

      var add   = ADDS[tier];
      var raw   = base + add;
      var d     = disc(qty);
      var unit  = raw * (1 - d);
      var tot   = unit * qty;
      var saved = raw * d * qty;
      var ok    = qty >= 100;

      document.getElementById('deve-unit-'     + id).textContent = fmt(unit);
      document.getElementById('deve-units-'    + id).textContent = ok ? qty.toLocaleString('en-IN') : '—';
      document.getElementById('deve-total-'    + id).textContent = ok ? fmt(tot) : '—';
      document.getElementById('deve-tier-lbl-' + id).textContent = LABELS[tier];
      
      document.getElementById('db-base-'       + id).textContent = fmt(base) + ' / unit';
      document.getElementById('db-custom-'     + id).textContent = add > 0 ? '+' + fmt(add) + ' / unit' : 'Nil';
      document.getElementById('db-disc-'       + id).textContent = d > 0 ? '\u2212' + (d * 100).toFixed(0) + '% (' + fmt(saved) + ')' : 'Nil';
      document.getElementById('db-tot-'        + id).textContent = ok ? fmt(tot) : 'Enter valid qty';
      document.getElementById('deve-saving-' + id).textContent =
        d > 0
          ? 'Saving ' + fmt(raw * d) + ' per unit'
          : qty >= 100
            ? 'From 150 units for 8% off'
            : 'Minimum order: 100 units';

      var cta = document.getElementById('deve-cta-' + id);
      var productId = document.getElementById('deve-est-' + id).getAttribute('data-product-id') || '';
      if (cta) {
        // Freeze the original base URL once on first call — never read back from cta.href
        if (!cta.dataset.baseHref) {
          var raw_href = cta.getAttribute('href') || '';
          var qi = raw_href.indexOf('?');
          cta.dataset.baseHref = qi !== -1 ? raw_href.substring(0, qi) : raw_href;
        }
        if (ok) {
          var msg = 'Bulk Quote Request'
            + (productId ? '\nProduct ID: ' + productId : '')
            + '\nProduct: ' + (document.title || window.location.pathname)
            + '\nUnits: ' + qty
            + '\nCustomisation: ' + LABELS[tier]
            + '\nOriginal unit price: ' + fmt(raw)
            + (d > 0 ? '\nBulk discount: ' + (d * 100).toFixed(0) + '% — saving ' + fmt(raw * d) + ' per unit' : '\nBulk discount: Nil')
            + '\nDiscounted unit price: ' + fmt(unit)
            + '\nEstimated total: ' + fmt(tot);
          cta.setAttribute('href',
            cta.dataset.baseHref
            + '?msg=' + encodeURIComponent(msg)
          );
          cta.classList.remove('deve-btn--inactive');
          cta.removeAttribute('aria-disabled');
        } else {
          cta.setAttribute('href', cta.dataset.baseHref);
          cta.classList.add('deve-btn--inactive');
          cta.setAttribute('aria-disabled', 'true');
        }
      }
    };

    function deveInitAll() {
      document.querySelectorAll('[id^="deve-qty-"]').forEach(function (el) {
        el.dispatchEvent(new Event('input'));
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', deveInitAll);
    } else {
      // DOMContentLoaded already fired (common with Shopify's deferred JS bundles)
      deveInitAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
